namespace Areas {
    "use strict";

    export class UpdateOperations {

        form: DevExpress.ui.dxForm;
        url: string;
        getMoreData: (any) => void;

        constructor(formName: string, url: string, getMoreData?: (any) => void) {
            const formId = `#${formName}`;
            this.form = $(formId).dxForm("instance");
            this.url = url;

            if (getMoreData) {
                this.getMoreData = getMoreData;
            }
        }

 
        updateRecord() {
            const newData: any = this.form.option("formData");
     
            if (this.getMoreData) {
                this.getMoreData(newData);
            }

            const result: any = this.form.validate();
            console.log(result);
            if ($('#result').length > 0) {
                if (result.isValid) {
                    sendRequest(this.url, JSON.stringify(newData), "PUT");
                }     
            } else {
                sendRequest(this.url, JSON.stringify(newData), "PUT");
            }
        }

        updateRecordWithId() {
            const newData: any = this.form.option("formData");

            if (this.getMoreData) {
                this.getMoreData(newData);
            }

            const result: any = this.form.validate();
            const keyId: any = this.form.option("KeyId");

            if (result.isValid && keyId != null) {
                sendRequest(`${this.url}/${keyId}`, JSON.stringify(newData), "PUT");
            }            
        }

      
    }








}